<div class="frame">
    <div #container class="container">
        <div class="innerLogin fadeInClass06">
            <form novalidate autocomplete="off" [formGroup]="m_contGroup">
                <mat-form-field style="width: 300px">
                    <mat-label style="color: white">select scene...</mat-label>
                    <input matInput type="text" name="answerField"
                           placeholder="scene"
                           formControlName="answerField"
                           (keydown.enter)="onClick()"
                           [matAutocomplete]="auto"
                           autocomplete="off">
                    <button matSuffix mat-icon-button type="button" aria-label="Clear" (click)="clear()">
                        <mat-icon>more_vert</mat-icon>
                    </button>
                    <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
                        <cdk-virtual-scroll-viewport [itemSize]="7" class="answer-dropdown" #viewport>
                            <mat-option class="answer" [value]="scene" *cdkVirtualFor="let scene of m_scenes$ | async">
                                <div class="cut-text">{{scene.label}} <span
                                        style="opacity: 0.1"> ID: {{scene?.id}}</span></div>
                            </mat-option>
                        </cdk-virtual-scroll-viewport>
                    </mat-autocomplete>
                </mat-form-field>
            </form>
            <mat-form-field style="width: 300px">
                <input placeholder="player name" type="text" matInput #stationName [disabled]="blockUI"
                       (keydown.enter)="onClick()"
                       [(ngModel)]="m_stationName"  class="item">
            </mat-form-field>
            <br/>
            <!--            <mat-select #scene placeholder="select scene to play" panelClass="reg-panel" [disabled]="blockUI" [(ngModel)]="selected" class="item">-->
            <!--                <mat-option class="optionColor" [value]="scene.id" *ngFor="let scene of scenes">{{scene.label}}</mat-option>-->
            <!--            </mat-select>-->
            <div style="text-align: center">
                <button mat-raised-button #btnRegister [disabled]="blockUI || !selected || m_stationName.length < 2"
                        type="button" class="buttonStart" (click)="onClick()">
                    <span style="position: relative; top: -3px">register</span>
                    <mat-icon [ngStyle]="{'opacity': blockUI || !selected || m_stationName.length < 2 ? '0.2' : '1'}">check_circle_outline</mat-icon>
                </button>
            </div>
        </div>
    </div>
</div>
<ng-template let-modal #popup>
    <h1 class="header" mat-dialog-title cdkDrag cdkDragRootElement=".cdk-overlay-pane">
        <mat-icon class="labelStyle pull-right">desktop_mac</mat-icon>
        <div style="color: white" class="move labelStyle pull-right dlg-drag-handle" cdkDragHandle>
            <svg width="24px" fill="currentColor" viewBox="0 0 24 24">
                <path d="M10 9h4V6h3l-5-5-5 5h3v3zm-1 1H6V7l-5 5 5 5v-3h3v-4zm14 2l-5-5v3h-3v4h3v3l5-5zm-9 3h-4v3H7l5 5 5-5h-3v-3z"></path>
                <path d="M0 0h24v24H0z" fill="none"></path>
            </svg>
        </div>
    </h1>
    <div class="modal-body">
        <label class="labelStyle ver">{{popupMessage}}</label>
        <hr/>
        <label class="labelStyle ver"></label>
        <td><label class="labelStyle"></label></td>
        <br/>
        <br/>
        <button mat-raised-button class="infoButton buttonStart" type="button" (click)="onClose()">
            <mat-icon>close</mat-icon>
        </button>
    </div>
</ng-template>



